import {IconProps} from './types';

function ConferenceBadge({stroke = 'currentColor'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="8" cy="3.5" r="1.5" stroke={stroke} strokeWidth="0.6"/>
            <path d="M5.5 8.5C5.5 7.12 6.62 6 8 6C9.38 6 10.5 7.12 10.5 8.5V9.5H5.5V8.5Z" stroke={stroke} strokeWidth="0.6"/>
            <path d="M4 11.5H12" stroke={stroke} strokeWidth="0.6" strokeLinecap="round"/>
            <path d="M5 11.5V14M11 11.5V14M6.5 14H9.5" stroke={stroke} strokeWidth="0.6" strokeLinecap="round"/>
        </svg>
    );
}

export default ConferenceBadge;
